export default "__VITE_ASSET__DYHn9Ktw__"